export const API_ROUTES = {
  HEALTH: "/health",

  SIGN_IN: "/auth/sign-in",
  SIGN_UP: "/auth/sign-up",
  SIGN_OUT: "/auth/sign-out",
  FORGOT_PASSWORD: "/auth/forgot-password",
  REFRESH: "/auth/refresh",

  GET_ME: "/users/me",

  GET_RECIPES: (query: string) => `/recipes?${query}`,
  GET_FAVORITE_RECIPES: "/recipes/favorites",
  GET_RECIPE_BY_ID: (id: string) => `/recipes/${id}`,
  POST_GENERATED_RECIPE_BY_URL: "/recipes/generate-recipe-from-video-url",
  CREATE_RECIPE: "/recipes/new",
  UPDATE_RECIPE: (id: string) => `/recipes/update/${id}`,
  GET_RECENTLYT_VIEWED_RECIPES: "/recipes/recently-viewed-recipes",
  SET_RECIPE_RATING: (id: string) => `/recipes/${id}/rating`,
  DELETE_RECIPE: (id: string) => `/recipes/${id}`,

  TOGGLE_FAVORITE: "/users/favorites",

  GET_CATEGORIES: "/categories",
};
